import { get, post, put, del } from "../../../utils/axios";

export const getLocationDetails = async (id) => {
  return await get("/location/detail", { id: parseInt(id, 10) });
};

export const createLocationDetails = async (body) => {
  return await post("/location", body);
};

export const updateLocationDetails = async (body) => {
  return await put("/location", {}, body);
};

export const deleteLocationDetails = async (id) => {
  return await del("/location", { id: parseInt(id, 10) });
};